/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type RefreshTwitterCredentialsInput = {
    readonly clientMutationId: string;
    readonly id: string;
};
export type refreshTwitterCredentialsMutationVariables = {
    readonly input: RefreshTwitterCredentialsInput;
};
export type refreshTwitterCredentialsMutationResponse = {
    readonly refreshTwitterCredentials: {
        readonly clientMutationId: string | null;
        readonly credentials: {
            readonly id: string;
            readonly twitterUserId: string | null;
            readonly openIdToken: string | null;
        } | null;
        readonly hasErrors: boolean | null;
        readonly errors: ReadonlyArray<{
            readonly created: unknown | null;
            readonly id: string;
            readonly location: string | null;
            readonly type: string | null;
        } | null> | null;
    } | null;
};
export type refreshTwitterCredentialsMutation = {
    readonly response: refreshTwitterCredentialsMutationResponse;
    readonly variables: refreshTwitterCredentialsMutationVariables;
};



/*
mutation refreshTwitterCredentialsMutation(
  $input: RefreshTwitterCredentialsInput!
) {
  refreshTwitterCredentials(input: $input) {
    clientMutationId
    credentials {
      id
      twitterUserId
      openIdToken
    }
    hasErrors
    errors {
      created
      id
      location
      type
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "RefreshTwitterCredentialsInput!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "refreshTwitterCredentials",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RefreshTwitterCredentialsPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "clientMutationId",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "credentials",
        "storageKey": null,
        "args": null,
        "concreteType": "TwitterUser",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "twitterUserId",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "openIdToken",
            "args": null,
            "storageKey": null
          }
        ]
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "hasErrors",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "errors",
        "storageKey": null,
        "args": null,
        "concreteType": "Error",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "created",
            "args": null,
            "storageKey": null
          },
          (v1/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "location",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "type",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "refreshTwitterCredentialsMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "refreshTwitterCredentialsMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "refreshTwitterCredentialsMutation",
    "id": null,
    "text": "mutation refreshTwitterCredentialsMutation(\n  $input: RefreshTwitterCredentialsInput!\n) {\n  refreshTwitterCredentials(input: $input) {\n    clientMutationId\n    credentials {\n      id\n      twitterUserId\n      openIdToken\n    }\n    hasErrors\n    errors {\n      created\n      id\n      location\n      type\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
(node as any).hash = 'ac7c026dd2bcf318d1961acbbe9e6434';
export default node;
